export default __webpack_public_path__ + "static/media/Velmurugan Jewellery Logo Final 1.01d201e6.jpg";